import * as React from 'react';

const SvgInfo = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 92 92" width="1em" height="1em" {...props}>
        <path d="M43.3 73.8c-.8 0-1.6-.3-2.2-.8-1-.8-1.5-2.1-1.2-3.4l4.9-25-2.7 1.5c-1.7.9-3.8.4-4.8-1.3-.9-1.7-.4-3.8 1.3-4.8l9.3-5.3c1.2-.7 2.7-.6 3.8.2 1.1.8 1.6 2.2 1.4 3.5l-5.1 26 4.2-1.8c1.8-.8 3.8 0 4.6 1.8.8 1.8 0 3.8-1.8 4.6l-10.3 4.5c-.4.2-.9.3-1.4.3zM53.2 26c.9-.9 1.5-2.2 1.5-3.5 0-1.3-.5-2.6-1.5-3.5-.9-.9-2.2-1.5-3.5-1.5-1.3 0-2.6.5-3.5 1.5-.9.9-1.5 2.2-1.5 3.5 0 1.3.5 2.6 1.5 3.5.9.9 2.2 1.5 3.5 1.5 1.3 0 2.6-.5 3.5-1.5zM92 46C92 20.6 71.4 0 46 0S0 20.6 0 46s20.6 46 46 46 46-20.6 46-46zm-8 0c0 21-17 38-38 38S8 67 8 46 25 8 46 8s38 17 38 38z" />
    </svg>
);

export default SvgInfo;
